// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n#searchIN::-webkit-search-cancel-button{\n    display: none;\n    right:0px;\n}\n", ""]);
// Exports
module.exports = exports;
